export const renderClientName = (client) => {
    return client
        ? `${client?.code ? `(${client?.code}) ` : ''}${client?.firstName ? `${client?.firstName}` : ''}${client?.middleName ? ` ${client?.middleName?.slice(0, 1)}.` : ''}${client?.lastName ? ` ${client?.lastName}` : ''}`
        : '--';
};

export const renderStaffName = (staff) => {
    return staff
        ? `${staff?.firstName ? staff?.firstName : ''}${staff?.middleName ? ` ${staff?.middleName?.slice(0, 1)}.` : ''}${staff?.lastName ? ` ${staff?.lastName}` : ''}`
        : '--';
};

export const CLIENT_ACTION = 'GET_BASIC_CLIENTS';
export const GET_FUNDING_SOURCE = 'GET_FUNDING_SOURCE';

export const INVOICE_STATUSES = [
    { name: 'Open', id: 'OPEN' },
    { name: 'Paid', id: 'PAID' },
    { name: 'Closed', id: 'CLOSED' },
];
